export const chatUserMatchesSearch = (user, searchText) => {
  const normalizedSearchText = searchText.trim().toLowerCase();

  if (!normalizedSearchText) {
    return true;
  }

  return [user?.name, user?.email, user?.id].some((value) =>
    value?.toString().toLowerCase().includes(normalizedSearchText)
  );
};

export const filterChatUsers = (users, searchText) =>
  users.filter((user) => chatUserMatchesSearch(user, searchText));

export const canCreateChatChannel = (channelName, selectedMembers) =>
  Boolean(
    channelName?.trim().length > 0 &&
      Array.isArray(selectedMembers) &&
      selectedMembers.length > 0
  );

// 1:1 conversations only; group DMs are keyed by cid like channels so a
// group with Sam doesn't dedupe against the 1:1 with Sam
export const getDirectMessageUserId = (channel, currentUserId) => {
  if (!channel?.cid || channel.type !== "messaging") {
    return null;
  }

  const otherMembers = Object.values(channel.state?.members || {}).filter(
    ({ user }) => user?.id?.toString() !== currentUserId?.toString()
  );
  if (otherMembers.length !== 1) {
    return null;
  }

  return otherMembers[0]?.user?.id?.toString() || null;
};

export const mergeChatSearchResults = (currentUserId, ...resultGroups) => {
  const seen = new Set();
  const mergedResults = [];

  resultGroups.flat().forEach((result) => {
    const directMessageUserId = getDirectMessageUserId(result, currentUserId);
    const resultKey = directMessageUserId
      ? `dm:${directMessageUserId}`
      : result?.cid
        ? `channel:${result.cid}`
        : result?.id
          ? `dm:${result.id}`
          : null;

    if (!resultKey || seen.has(resultKey)) {
      return;
    }

    seen.add(resultKey);
    mergedResults.push(result);
  });

  return mergedResults;
};
